/* eslint-disable react-refresh/only-export-components */
import { useState } from "react";
import { IconButton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export interface ProposalEntry {
  nip: string;
  name: string;
  source: "MF" | "GUS";
}

export const PROPOSAL_SOURCE_STYLE: Record<"MF" | "GUS", { color: string; bg: string }> = {
  MF:  { color: "#1565c0", bg: "rgba(21,101,192,0.10)" },
  GUS: { color: "#6a1b9a", bg: "rgba(106,27,154,0.10)" },
};

export const ManualNipInput = ({ onAccept }: { onAccept: (nip: string) => void }) => {
  const [value, setValue] = useState("");
  const clear = () => setValue("");
  const accept = () => { if (value.length === 10) { onAccept(value); clear(); } };
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      <input
        value={value}
        maxLength={10}
        placeholder="Wpisz NIP ręcznie"
        onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 10))}
        onKeyDown={(e) => {
          if (e.key === "Enter") accept();
          if (e.key === "Escape") clear();
          e.stopPropagation();
        }}
        onClick={(e) => e.stopPropagation()}
        style={{ width: 108, fontSize: 11, padding: "3px 6px", borderRadius: 6, border: "1px solid #ccc", outline: "none", fontFamily: "monospace" }}
      />
      <IconButton size="small" disabled={value.length !== 10} onMouseDown={(e) => e.preventDefault()} onClick={(e) => { e.stopPropagation(); accept(); }} sx={{ color: "#2e7d32", p: "2px", minWidth: 0, "&.Mui-disabled": { color: "#bbb" } }}>
        <CheckIcon sx={{ fontSize: 16 }} />
      </IconButton>
      <IconButton size="small" disabled={value.length === 0} onMouseDown={(e) => e.preventDefault()} onClick={(e) => { e.stopPropagation(); clear(); }} sx={{ color: "#c62828", p: "2px", minWidth: 0, "&.Mui-disabled": { color: "#bbb" } }}>
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </div>
  );
};
